import React, { useEffect, useState } from 'react';

export default function Countdown(props) {
  const {
    initialSeconds = 0,
    className = '',
    countdownString = '{{sec}}s',
    domAfterZero=<span/>,
    onSecondsChange
    } = props;
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (onSecondsChange) onSecondsChange(seconds);
      if (seconds > 0) setSeconds(seconds - 1);
      if (seconds === 0) clearInterval(myInterval);
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  return (
    <div className={className}>
      {seconds > 0 && <span>{countdownString.replace('{{sec}}', seconds)}</span>}
      {seconds === 0 && domAfterZero}
    </div>
  );
}